import { Navigate } from 'react-router-dom';
import { ROUTES } from '@/app/config/constants';
import { TEMPLATES_MENU_CHILDREN } from '@/app/layout';
import { useFeatureAccess } from '@/features/authentication';

/**
 * Where `/templates` lands: the first template this role may actually read.
 *
 * A fixed redirect to the PR template sent everyone there, so a role granted only the RFQ template
 * clicked Templates in their sidebar and was refused by a template it was never given. The order is the
 * menu's, so the landing is the first child the role can see.
 *
 * With nothing reachable it falls back to the declared default and that route's own guard refuses it --
 * one refusal, from the same source, rather than a second rule about emptiness here. In practice the
 * sidebar has already dropped the whole group in that case.
 *
 * The Masters group solves the same problem the same way; see `MastersLanding`.
 */
export function TemplatesLanding() {
  const { canReach } = useFeatureAccess();
  const first = TEMPLATES_MENU_CHILDREN.find(
    (child) => child.feature !== undefined && canReach(child.feature),
  );

  return <Navigate to={first?.path ?? ROUTES.TEMPLATES_PR} replace />;
}
